import { Typeahead } from '@panwds/react-ui';
import { noop } from 'lodash';
import React, { useState } from 'react';
import { useFilters } from '../../hooks/index.js';
import { Pill } from '../Pill/index.js';
export function TypeAheadFilter({ name, required = false, static: isStatic, onClose, onClear, onKeyUp, dataMetrics, dataTestId, label = '', id = 'type-ahead-filter', ...rest }) {
    const { setFilters, filters } = useFilters();
    // This exists for the parent component to query the input value for results
    // No need to set an initial state because keyup will get the input value - User provided value
    const [input, setInput] = useState('');
    const handleInputChange = (txt) => setInput(txt);
    const onKeyUpGetInput = (event) => {
        onKeyUp(event, input);
    };
    // Send drop down selections to global filter state
    const onChange = (value) => {
        setFilters({ [name]: value.label });
    };
    const onFilterCloseAndOptionsClear = (e) => {
        onClose?.(e);
        onClear?.();
    };
    return (React.createElement("div", { id: id },
        React.createElement(Pill, { label: label, required: required, static: isStatic, onClose: onFilterCloseAndOptionsClear, select: React.createElement(Typeahead, { ...rest, addInputClassName: "twds-ml-2 twds-border-none twds-h-full", onChange: onChange, onClose: noop, onInputChange: handleInputChange, onKeyUp: onKeyUpGetInput, 
                // TODO: This component doesn't work for multi-select filters but
                // has no guard rails against this misuse. The typedef for `filters`
                // was previously broken so this was not made clear. The `as string`
                // assertion is used for now merely to appease the compiler.
                defaultValue: filters[name], dataMetrics: `type-ahead-filter-${dataMetrics || name}`, dataTestId: `type-ahead-filter-${dataTestId || name}` }) })));
}
//# sourceMappingURL=TypeAheadFilter.js.map